module.exports = __webpack_public_path__ + "img/cruise.b6bed3ef.svg";